// EVA-266 (Tier 1 unification): the search predicate for the shared
// TenantSelectorModal. Pure (no React/DOM) so it can be unit-tested under Node.
// Matches a query as a case-insensitive substring of the tenant's
// name / suite / lease start / lease end, joined by spaces.
export function filterTenants(tenants, query) {
  const q = (query || '').trim().toLowerCase()
  if (!q) return tenants
  return tenants.filter((t) =>
    `${t.title || ''} ${t.suite || ''} ${t.lease_start_date || ''} ${t.lease_end_date || ''}`
      .toLowerCase()
      .includes(q)
  )
}
